module.exports = __webpack_public_path__ + "static/media/Kissen_70x70_rueckseite.226c1b08.png";